import { createHistoryEntryType } from "../../api/historyService";

export const useCreateHistoryEntryType = (successCallback) => {
    const create = async (data) => {
        try {
            const newRecord = await createHistoryEntryType(data);
            if (successCallback)
            {
                successCallback(newRecord);
            }
            return newRecord;
        } catch (error) {
            console.error("Failed to create history entry type:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};